import { withStyles, createStyles, TableCell, Theme, makeStyles } from "@material-ui/core";

export const useTableStyles = makeStyles((theme: Theme) => ({
    header: {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.common.white,
        padding: `${theme.spacing(2)}px ${theme.spacing(2)}px`
    }
}))

export const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: theme.palette.secondary.light,
            color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }),
)(TableCell);
